var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210,
    height: 114
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cancel-success_svg__c",
    x1: "154.258%",
    x2: "0%",
    y1: "24.046%",
    y2: "59.452%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "36.062%",
    stopColor: "#FFD97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFE577"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cancel-success_svg__a",
    d: "M0 0h210v114H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cancel-success_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel-success_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#cancel-success_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDB74",
    d: "M168.864 5.839h11.776c14.534 0-9.799-4.147 0-4.147h53.188c49.62 0 66.313.377 44.699 4.147-21.614 3.77-19.042 1.13 19.801 0 38.843-1.131 20.674 7.785-23.174 7.785-43.849 0-165.972 3.022-142.978 0 15.33-2.014 38.443-3.78 69.341-5.294l-32.653-2.491z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FCFE",
    d: "M94.474 42.861c-8.494-.25-15.389-1.03-20.684-2.337a5.21 5.21 0 00-7.607-6.938 9.66 9.66 0 00-8.765-5.595 9.66 9.66 0 00-8.827 5.729 5.21 5.21 0 00-8.115 1.673 3.861 3.861 0 00-5.177 2.987c-.484.44-1.047.93-1.687 1.473-2.246 1.906-10.13 2.908-23.656 3.008h84.518z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cancel-success_svg__c)",
    d: "M0 149c2.866-23.566 17.353-35.349 43.46-35.349 39.162 0 42.378-33.404 68.711-46.57 26.333-13.166 36.121 8.689 64.774-10.97 28.653-19.66 49.772-36.498 80.589-21.123C278.079 45.238 281.48 83.242 267.739 149H0z",
    transform: "translate(-22 1)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#563A07"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7A11F",
    strokeLinejoin: "round",
    strokeWidth: 3.81,
    d: "M170.223 36.772a7.62 7.62 0 017.62 7.619v25.953a7.62 7.62 0 01-7.62 7.62h-13.59 0c0-2.917-2.374-5.281-5.302-5.281-2.929 0-5.303 2.364-5.303 5.28H94.262a7.617 7.617 0 01-7.62-7.618V44.392a7.619 7.619 0 017.619-7.62h51.767c0 2.917 2.374 5.281 5.303 5.281 2.928 0 5.302-2.364 5.302-5.281h13.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 3.81,
    d: "M168.699 36.772a9.142 9.142 0 019.143 9.142v22.908a9.142 9.142 0 01-9.143 9.143h-12.066 0c0-2.917-2.374-5.281-5.302-5.281h-.035V42.053h.035c2.928 0 5.302-2.364 5.302-5.281h12.066z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3.81,
    d: "M87.574 48.764h89.504"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M95.071 58.066h14.54m-14.54 5.724h21.493m-21.493 5.724h30.642"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFDE79",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M90.818 93.359l87.746-73.171"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#563A07",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M89.209 91.741l87.746-73.171"
  })))));
}
export default SvgCancelSuccess;